import {
  useFollowParentSchedulePreview,
  type UseFollowParentSchedulePreviewResult,
} from '@/shared/hooks/useFollowParentSchedulePreview'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface UseFollowParentDepartmentSchedulePreviewArgs {
  /** When false (Follow Site OFF or edit), no partial reloads run. */
  enabled: boolean
  departmentId: number | null
  parentDaySchedule: WeekdaySchedule | undefined
  /** Seeded create already has a matching server preview — skip the first reload. */
  initialDepartmentId?: number | null
  /**
   * Bump after exhausted preview to retry without requiring Follow OFF→ON
   * (Units create / Batch — single Follow toggle uses Try again).
   */
  retryNonce?: number
}

/**
 * Live parent (site) day-schedule preview while Follow Site is ON on Units create.
 * Thin wrapper around useFollowParentSchedulePreview (E45-S1).
 */
export const useFollowParentDepartmentSchedulePreview = ({
  enabled,
  departmentId,
  parentDaySchedule,
  initialDepartmentId = null,
  retryNonce = 0,
}: UseFollowParentDepartmentSchedulePreviewArgs): UseFollowParentSchedulePreviewResult =>
  useFollowParentSchedulePreview({
    enabled,
    parentId: departmentId,
    parentDaySchedule,
    initialParentId: initialDepartmentId,
    retryNonce,
    reloadParamKey: 'department_id',
  })
